export const name = "STARTS_WITH";
export const summary = `Checks if a \`STRING\` or \`BYTES\` value is a prefix of another value.`;
export const reference = `
## STARTS_WITH

Checks if a \`STRING\` or \`BYTES\` value is a prefix of another value.

\`\`\`
STARTS_WITH(value, prefix)
\`\`\`

### Description

Takes two \`STRING\` or \`BYTES\` values. Returns \`TRUE\` if \`prefix\` is a prefix of \`value\`.

This function supports specifying collation.


### Return type

\`BOOL\`


### Examples



\`\`\`
SELECT STARTS_WITH('bar', 'b') AS example

/*---------*
 | example |
 +---------+
 | True |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
